import { UrlMatchResult, UrlSegment } from '@angular/router';
import { getProductCodeFromUrl } from 'haba-core';

/**
 * Matches pattern `p/{productName}--:productCode`
 * @param segments
 */
export function customProductUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const length = segments.length >= 2;
  const firstSegmentPath = segments[0]?.path;
  const oldProductCode =
    segments.length === 1 && firstSegmentPath?.includes('--')
      ? getProductCodeFromUrl(firstSegmentPath)
      : undefined;
  if ((length && firstSegmentPath === 'p') || oldProductCode) {
    const productCode = oldProductCode || getProductCodeFromUrl(segments[1].path);
    return {
      consumed: segments,
      posParams: { productCode: new UrlSegment(productCode, {}) },
    };
  }
  return null;
}
